import React from 'react'
import Nav from './Components/Nav'
import Footer from './Components/Footer'

const Work = () => {
  return (
    <div className="Main">
      <div className="container">
        <img className="vik-img" src="/images/coverWork.png" alt="" />
        <Nav/>
      </div>
      <div className="About_sec">
        <p>
        the work section is.., a work in progress.
        </p>
        </div>
      <Footer/>
    </div>
  )
}

export default Work